module.exports = __webpack_public_path__ + "static/5-more-incremental-b329cebfe8f2f32df462580ba3c1ee5c.svg";